import { type CustomClaims } from "@fitness-app/data-models/entities/UserProfile";

interface ClientCustomClaims {
  role: "CLIENT";
  memberId?: never;
  memberRole?: never;
  permissions?: never;
  permissionsVersion?: never;
  status?: never;
  trainerId?: never;
}

export type AppCustomClaims = CustomClaims | ClientCustomClaims;

const SUPPORTED_CLAIM_ROLES = new Set(["CLIENT", "TEAM_MEMBER", "TRAINER"]);

export const normalizeCustomClaims = (value: unknown): AppCustomClaims | null => {
  if (!value || typeof value !== "object" || !("role" in value)) {
    return null;
  }

  const role = value.role;
  return typeof role === "string" && SUPPORTED_CLAIM_ROLES.has(role) ? (value as AppCustomClaims) : null;
};
